<template>
        <tr v-if="coordsChanged && showMaps === false">
            <td style="padding: 0 5px;">
                <table style="width: 100%"  @click="setOldCoords">
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">markLat: {{ o.markLat }}</td></tr>
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">markLong: {{ o.markLong }}</td></tr>
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">mapZoom: {{ o.mapZoom }}</td></tr>
                </table>
            </td>
            <td style="padding: 0 5px;">
                <table style="width: 100%">
                    <tr><td class="selected"  width="100%" valign="top">
                        markLat: {{ res.markLat }}
                        <button @click="showMaps=!showMaps" class="mapButton">Карта</button>
                    </td></tr>
                    <tr><td class="selected"  width="100%" valign="top">markLong: {{ res.markLong }}</td></tr>
                    <tr><td class="selected"  width="100%" valign="top">mapZoom: {{ res.mapZoom }}</td></tr>
                </table>
            </td>
            <td style="padding: 0 5px;">
                <table style="width: 100%" @click="setNewCoords">
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">markLat: {{ n.markLat }}</td></tr>
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">markLong: {{ n.markLong }}</td></tr>
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">mapZoom: {{ n.mapZoom }}</td></tr>
                </table>
            </td>
        </tr>
        <tr v-else-if="!coordsChanged && showMaps === false">
            <td style="padding: 0 5px;"></td>
            <td style="padding: 0 5px;"></td>
            <td style="padding: 0 5px;"></td>
        </tr>
        <tr v-else-if="showMaps===true">
            <td style="padding: 0 5px;">
                <table style="width: 100%"  @click="setOldCoords">
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">markLat: {{ o.markLat }}</td></tr>
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">markLong: {{ o.markLong }}</td></tr>
                    <tr><td :class="{'selected': isOld}" width="100%" valign="top">mapZoom: {{ o.mapZoom }}</td></tr>
                </table>
                <current-map id="mapOld" :markLat="Number(o.markLat)" :markLong="Number(o.markLong)" :mapZoom="Number(o.mapZoom)" :disable="true" /></td>
            <td style="padding: 0 5px;">
                <table style="width: 100%" @click="showMaps=!showMaps">
                    <tr><td :class="{'selected': true}"  width="100%" valign="top">
                        <button @click="showMaps=!showMaps" class="mapButton">Скрыть</button>
                        markLat: {{ res.markLat }}
                    </td></tr>
                    <tr><td :class="{'selected': true}"  width="100%" valign="top">markLong: {{ res.markLong }}</td></tr>
                    <tr><td :class="{'selected': true}"  width="100%" valign="top">mapZoom: {{ res.mapZoom }}</td></tr>
                </table>
                <current-map id="mapCur" ref="mapCur" @updateCoords="onUpdateCoords" :markLat.sunc="Number(res.markLat)" :markLong.sunc="Number(res.markLong)" :mapZoom.sunc="Number(res.mapZoom)" />
            </td>
            <td style="padding: 0 5px;">
                <table style="width: 100%" @click="setNewCoords">
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">markLat: {{ n.markLat }}</td></tr>
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">markLong: {{ n.markLong }}</td></tr>
                    <tr><td :class="{'selected': isNew}"  width="100%" valign="top">mapZoom: {{ n.mapZoom }}</td></tr>
                </table>
                <current-map id="mapNew" :markLat="Number(n.markLat)" :markLong="Number(n.markLong)" :mapZoom="Number(n.mapZoom)" :disable="true" />
            </td>
        </tr>
</template>
<script>
import CurrentMap from './ymaps/CurrentMap';

export default {
    components: {
        CurrentMap
    },
    props: {
        n: {
            type: Object,
            required: true
        },
        o: {
            type: Object,
            required: true
        },
        f: {
            type: Object,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
    },
        data: function () {
            return {
                res: this.f,
                showMaps: false,
            }
        },
    methods: {
        onUpdateCoords (markLat, markLong, mapZoom) {
            this.res.markLat = String(markLat);
            this.res.markLong = String(markLong);
            this.res.mapZoom = String(mapZoom);
        },
        updateMap (markLat, markLong, mapZoom){
            if(this.showMaps){
                this.$refs.mapCur.update(markLat, markLong, mapZoom);
            }
        },
        setNewCoords () {
            this.res.markLat = this.n.markLat;
            this.res.markLong = this.n.markLong;
            this.res.mapZoom = this.n.mapZoom;

            this.updateMap(this.n.markLat, this.n.markLong, this.n.mapZoom);
        },
        setOldCoords () {
            this.res.markLat = this.o.markLat;
            this.res.markLong = this.o.markLong;
            this.res.mapZoom = this.o.mapZoom;

            this.updateMap(this.o.markLat, this.o.markLong, this.o.mapZoom);
        }
    },
    computed: {
        isNew(){
            return this.res.markLat == this.n.markLat
                && this.res.markLong == this.n.markLong
                && this.res.mapZoom == this.n.mapZoom;
        },
        isOld(){
            return this.res.markLat == this.o.markLat
                && this.res.markLong == this.o.markLong
                && this.res.mapZoom == this.o.mapZoom;
        },
        coordsChanged () {
            return this.o.markLat !== this.n.markLat
                || this.o.markLong !== this.n.markLong
                || this.o.mapZoom !== this.n.mapZoom;
        }
    },
    watch: {
        f: function (value) {
            this.res = value;
        },
        res: function (value) {
            this.$emit('update:f', value)
        }
    },
    }
</script>
<style>
.mapButton {
    float: right;
    height: 25px;
    padding-top: 3px;
}
</style>
